export default __webpack_public_path__ + "static/media/donation.6c12422c.svg";